<div class="table-cell table-cell-wrapped" style="border: none;" *ngIf="groupZoneKeyName">
  <button class="btn btn-sm btn-icon white" (click)="expandCollapseGroup(this.dataIndex, $event)"
          *ngIf="isGroupCollapserVisible" [disabled]="isGroupCollapserDisabled">
    <i *ngIf="isGroupCollapserDisabled" class="fa fa-light fa-minus"></i>
    <i *ngIf="!isGroupCollapserDisabled && isGroupCollapserCollapsed" class="fa fa-solid fa-caret-right"></i>
    <i *ngIf="!isGroupCollapserDisabled && !isGroupCollapserCollapsed" class="fa fa-solid fa-caret-down"></i>
  </button>
</div>
<ng-template #tableCell></ng-template>
<div class="table-cell" *ngIf="cardDescriptor.isDated">
  <div class="form-group" *ngIf="editMode && !readOnly" style="min-width: 150px;">
    <datepicker-input
      [(ngModel)]="beginDateValue"
      (ngModelChange)="updateDate($event,'begindate')"
      [formControl]="beginDateControl"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [hasEternity]="true"
      [groupZoneID]="cardDescriptor.groupZoneID"
      [attr.test-id]="cardDescriptor.groupZoneID + '-beginDate-' + dataIndex"
      [parentScrollSelector]="'.table-responsive'">
    </datepicker-input>
  </div>
  <div [attr.data-hidden]="editMode" [ngClass]="{'dates-disabled': readOnly}">{{ displayDate(beginDateValue) }}</div>
  <ul class="error-list" *ngIf="group?.invalid && errorText">
    <li>{{ 'FORM_GENERATOR.ERRORS.' + errorText | translate }}</li>
  </ul>
</div>
<div class="table-cell" *ngIf="cardDescriptor.isDated">
  <div class="form-group" *ngIf="editMode && !readOnly" style="min-width: 150px;">
    <datepicker-input
      [(ngModel)]="endDateValue"
      (ngModelChange)="updateDate($event,'enddate')"
      [formControl]="endDateControl"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [hasEternity]="true"
      [groupZoneID]="cardDescriptor.groupZoneID"
      [attr.test-id]="cardDescriptor.groupZoneID + '-endDate-' + dataIndex"
      [parentScrollSelector]="'.table-responsive'">
    </datepicker-input>
  </div>
  <div [attr.data-hidden]="editMode" [ngClass]="{'dates-disabled': readOnly}">{{ displayDate(endDateValue) }}</div>
</div>
<td class="text-center pull-right" [attr.data-hidden]="readOnly" style="min-width: 95px; border: none;">
  <div class="btn-bar-wrapper">
    <div class="btn-bar btn-bar-sm">
      <button class="btn btn-sm btn-icon white"
              tooltip="{{ 'TOOLTIPS.clone_entry' | translate }}"
              container="body"
              type="button"
              placement="left"
              (click)="cloneEntity(this.dataIndex, $event)">
        <i class="far fa-clone"></i>
      </button>
      <button class="btn btn-sm btn-icon white"
              tooltip="{{ 'TOOLTIPS.delete_entry' | translate }}"
              container="body"
              placement="left"
              type="button"
              [disabled]="data?.default"
              (click)="removeEntity(this.dataIndex, $event)">
        <i class="fa fa-light fa-trash-alt"></i>
      </button>
    </div>
  </div>
</td>
